import React from "react";
import { CancellationPolicyProvider } from "./cancellationPolicy";
import { ClinicInfoProvider } from "./clinicInfo";
import { AvailabilityPickerProvider } from "./availabilityPicker";
import { useSelector } from "src/store";
import { ExitProvider } from "./exit";

export function ModalProviders({ children }: React.PropsWithChildren) {

    const clinicId = useSelector((state) => state.appointment.clinicId);
    const doctorId = useSelector((state) => state.appointment.doctorErpId);

    if (!clinicId || !doctorId) {
        return <ExitProvider>{children}</ExitProvider>;
    }

    return <CancellationPolicyProvider>
        <ClinicInfoProvider>
            <AvailabilityPickerProvider>
                <ExitProvider>
                    {children}
                </ExitProvider>
            </AvailabilityPickerProvider>
        </ClinicInfoProvider>
    </CancellationPolicyProvider>

}